import React, {Component} from 'react';
import Modal from 'react-modal';

const customStyles = {
    overlay: {
        backgroundColor: 'none'
    },
    content : {
        overflow                   : '',
        top                   : '',
        left                  : '',
        right                 : '',
        bottom                : '',
        marginRight           : '',
        transform             : '',
        padding             : '',
        border             : '',
        background             : '',
        borderRadius             : '',
    }
};

export default class ShooqModal extends Component {

    constructor(props) {
        super(props);
        let isOpen = props.showModal || false;
        this.state = {
            modalIsOpen: isOpen
        };

        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    afterOpenModal() {
    }

    closeModal(proxy) {
        this.setState({modalIsOpen: false});
        return this.props.onRequestClose(proxy) || true;
    }

    render() {
        let title = this.props.modalTitle || '';
        let modalSubTitle = this.props.modalSubTitle || '';
        let footer = this.props.modalFooter || '';
        return (
            <div>
                <Modal
                    portalClassName={`shooq-modal ${this.props.className || ``}`}
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="shooq-modal--box">
                        <div className="shooq-modal--header">
                            <div className="shooq-modal--header--title">{title}</div>
                            <div className="shooq-modal--header--sub-title">{modalSubTitle}</div>
                            <button className="shooq-modal--close" onClick={this.closeModal}>
                                <i className="zicon-cross"></i>
                            </button>
                        </div>
                        <div className="clearfix"></div>
                        <div className="shooq-modal--body">
                            {this.props.children}
                        </div>
                        <div className="clearfix"></div>
                        {footer.length > 0 ? (<div className="shooq-modal--footer">{footer}</div>):('')}
                    </div>
                </Modal>
            </div>
        );
    }

}
